import { ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewContainerRef } from '@angular/core';
import { PassKeyTermsSuccessFormComponent } from './pass-key-terms-success-form.component';

class PassKeySuccessFormSession implements com.ts.mobile.sdk.UIFormSession{
  clientContext: object;
  actionContext: object;
  formId: string;
  payload: object;
  isSuccess: boolean;;

  submitHandler: any;
  submitBlock: (payload: object) => void;
  resolver: ComponentFactoryResolver;
  viewContainerRef: ViewContainerRef;
  passKeyTermsSuccessFormComponent: ComponentRef<PassKeyTermsSuccessFormComponent>;

  constructor(formId: string, payload: object) {
    this.isSuccess = payload['success'];
  }
  startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
    console.log('PassKeySuccessFormSession: ' + this.formId);
    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.resolver = (clientContext as any).resolver;
    this.viewContainerRef = (clientContext as any).viewContainerRef;
  }
  endSession(): void {
    console.log('PassKeySuccessFormSession: ' + this.formId);
  }
  promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
    console.log('PassKeySuccessFormSession: ' + this.formId);
    const self = this;
    self.viewContainerRef.clear();

    const factory: ComponentFactory<PassKeyTermsSuccessFormComponent> =
            self.resolver.resolveComponentFactory(PassKeyTermsSuccessFormComponent);
    self.passKeyTermsSuccessFormComponent = self.viewContainerRef.createComponent(factory);

    self.passKeyTermsSuccessFormComponent.instance.isSuccess = this.isSuccess;
    self.passKeyTermsSuccessFormComponent.instance.onPasskeySuccessContinueSubmit = self.onPasskeySuccess.bind(self);

    // const journeyPayload = this.payload as JourneyPayload;
    // const action = journeyPayload.actions[0] as ActionsInPayload;

    return new Promise((resolve, reject) => {
      self.submitBlock = (payload: object) => {
        try {
          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));

          self.submitBlock = null;
        } catch (e) {

        }
      };
    });
  }
  onContinue(payload: object): void {
    console.log('PassKeySuccessFormSession ' + this.formId + ' payload:', payload);
  }
  onError(payload: object): void {
    const errorPayload = payload as JourneyPayload;
  }

  /** Non UIFormSession interface Functions */
  private onPasskeySuccess(payload: object) {
    const data = payload;
    this.submitBlock(data);
  }

}

interface JourneyPayload {
  actions: ActionsInPayload[];
  stat: string;
  code: string;
  flow: string;
  recaptchastatus: string;
  loginhint: string;
}

interface ActionsInPayload {
  [key: string]: any;
}

export default PassKeySuccessFormSession;
